import { lazyWithRetry } from 'utils/chunkLoadRecovery';
import { EnhancedPath } from 'utils/history';

export class TpoPortalPaths {
  // The Command Center is the default home for ALL authenticated users (DEV-4146),
  // so the canonical path is the role-neutral `/home` — not the legacy `/tpo/...`
  // namespace it lived under when it was the broker-only homepage.
  static commandCenter = new EnhancedPath('/home');

  // DEV-4041 renamed BrokerHome -> CommandCenter (`/command-center`); DEV-4151 moved the
  // canonical path off `/tpo/home`. Keep both as aliases so renamed and already-bookmarked
  // URLs still resolve to the same page instead of 404ing.
  static commandCenterAlias = new EnhancedPath('/command-center');

  static commandCenterLegacyAlias = new EnhancedPath('/tpo/home');
}

const commandCenterPage = lazyWithRetry(() => import('app/pages/tpoPortal/commandCenterHome'));

const routesConfig = {
  settings: {
    layout: {},
  },
  routes: [
    {
      path: TpoPortalPaths.commandCenter.path,
      component: commandCenterPage,
      exact: true,
      isAllowedWithoutRoles: true,
    },
    {
      path: TpoPortalPaths.commandCenterAlias.path,
      component: commandCenterPage,
      exact: true,
      isAllowedWithoutRoles: true,
    },
    {
      path: TpoPortalPaths.commandCenterLegacyAlias.path,
      component: commandCenterPage,
      exact: true,
      isAllowedWithoutRoles: true,
    },
  ],
};

export default routesConfig;
